<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<Offices :offices="groupedByOffice"></Offices>
			</v-row>
			<v-row class="pb-4 pl-4 pr-4">
				<v-flex xs12 md4 lg4 class="pa-0"
					><IncomeAndCostsChart :data="incomeAndCostsChartData"></IncomeAndCostsChart
				></v-flex>
				<v-flex xs12 md4 lg4 class="pa-0"><ProfitChart :data="profitChartData"></ProfitChart></v-flex>
				<v-flex xs12 md4 lg4 class="pa-0"
					><NumberOfCandidatesChart :data="numberOfCandidatesChartData"></NumberOfCandidatesChart
				></v-flex>
			</v-row>
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row class="d-flex justify-space-between">
								<v-col></v-col>
								<v-col class="pb-0 pt-0">
									<v-card-title class="d-flex justify-center align-center pa-2 pb-0 pt-0">{{
										$t('titles.statsCourses')
									}}</v-card-title>
								</v-col>
								<v-col class="d-flex justify-end pa-0 pl-2">
									<v-btn color="primary" @click="enrolledCandidatesViewClick">
										<v-icon small>fa-file-excel</v-icon>&nbsp;&nbsp;{{
											$t('buttons.enrolledCandidatesView')
										}}
									</v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="statsCoursesTable.additionalFilters"
										:default-sort="statsCoursesTable.defaultSort"
										:excel="true"
										:fields="statsCoursesTable.headers"
										:header-selection-key="'stats-courses-headers'"
										:height="statsCoursesTable.height"
										:total-records="statsCoursesTable.total"
										:filter-save-key="'stats-courses-filters'"
										@headers="selectHeaders"
										@excel="excelExport"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in statsCoursesTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td v-if="statsCoursesTable.selectedHeaders.includes('department')">
												{{ item.department }}
											</td>
											<td v-if="statsCoursesTable.selectedHeaders.includes('course_code')">
												{{ item.course_code }}
											</td>
											<td v-if="statsCoursesTable.selectedHeaders.includes('code')">
												{{ item.code }}
											</td>
											<td v-if="statsCoursesTable.selectedHeaders.includes('status')">
												{{ item.status }}
											</td>
											<td v-if="statsCoursesTable.selectedHeaders.includes('office')">
												{{ item.office }}
											</td>
											<td v-if="statsCoursesTable.selectedHeaders.includes('start_date')">
												{{
													item.start_date != null
														? item.start_date.split('-').reverse().join('.') + '.'
														: ''
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('income')"
											>
												{{
													Number(item.income) % 1 !== 0
														? item.income.charAt(item.income.length - 2) !== '0' &&
														  item.income.endsWith('0')
															? Number(item.income).toLocaleString('hr') + '0'
															: Number(item.income).toLocaleString('hr')
														: Number(item.income).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('discount')"
											>
												{{
													Number(item.discount) % 1 !== 0
														? item.discount.charAt(item.discount.length - 2) !== '0' &&
														  item.discount.endsWith('0')
															? Number(item.discount).toLocaleString('hr') + '0'
															: Number(item.discount).toLocaleString('hr')
														: Number(item.discount).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('cost')"
											>
												{{
													Number(item.cost) % 1 !== 0
														? item.cost.charAt(item.cost.length - 2) !== '0' &&
														  item.cost.endsWith('0')
															? Number(item.cost).toLocaleString('hr') + '0'
															: Number(item.cost).toLocaleString('hr')
														: Number(item.cost).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('profit')"
											>
												{{
													Number(item.profit) % 1 !== 0
														? item.profit.charAt(item.profit.length - 2) !== '0' &&
														  item.profit.endsWith('0')
															? Number(item.profit).toLocaleString('hr') + '0'
															: Number(item.profit).toLocaleString('hr')
														: Number(item.profit).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('registration')"
											>
												{{ item.registration }}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('income_candidate')"
											>
												{{
													Number(item.income_candidate) % 1 !== 0
														? item.income_candidate.charAt(
																item.income_candidate.length - 2
														  ) !== '0' && item.income_candidate.endsWith('0')
															? Number(item.income_candidate).toLocaleString('hr') + '0'
															: Number(item.income_candidate).toLocaleString('hr')
														: Number(item.income_candidate).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('discount_candidate')"
											>
												{{
													Number(item.discount_candidate) % 1 !== 0
														? item.discount_candidate.charAt(
																item.discount_candidate.length - 2
														  ) !== '0' && item.discount_candidate.endsWith('0')
															? Number(item.discount_candidate).toLocaleString('hr') + '0'
															: Number(item.discount_candidate).toLocaleString('hr')
														: Number(item.discount_candidate).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('cost_candidate')"
											>
												{{
													Number(item.cost_candidate) % 1 !== 0
														? item.cost_candidate.charAt(item.cost_candidate.length - 2) !==
																'0' && item.cost_candidate.endsWith('0')
															? Number(item.cost_candidate).toLocaleString('hr') + '0'
															: Number(item.cost_candidate).toLocaleString('hr')
														: Number(item.cost_candidate).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCoursesTable.selectedHeaders.includes('profit_candidate')"
											>
												{{
													Number(item.profit_candidate) % 1 !== 0
														? item.profit_candidate.charAt(
																item.profit_candidate.length - 2
														  ) !== '0' && item.profit_candidate.endsWith('0')
															? Number(item.profit_candidate).toLocaleString('hr') + '0'
															: Number(item.profit_candidate).toLocaleString('hr')
														: Number(item.profit_candidate).toLocaleString('hr') + ',00'
												}}
											</td>
										</tr>
										<tr>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td style="text-align: right">
												{{
													incomeSum != null
														? Number.isInteger(incomeSum)
															? incomeSum.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(incomeSum.toString())
															? incomeSum.toLocaleString('hr') + '0'
															: incomeSum.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{
													discountSum != null
														? Number.isInteger(discountSum)
															? discountSum.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(discountSum.toString())
															? discountSum.toLocaleString('hr') + '0'
															: discountSum.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{
													costSum != null
														? Number.isInteger(costSum)
															? costSum.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(costSum.toString())
															? costSum.toLocaleString('hr') + '0'
															: costSum.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{
													profitSum != null
														? Number.isInteger(profitSum)
															? profitSum.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(profitSum.toString())
															? profitSum.toLocaleString('hr') + '0'
															: profitSum.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{ registrationSum }}
											</td>
											<td style="text-align: right">
												{{
													incomeCandidateAvg != null
														? Number.isInteger(incomeCandidateAvg)
															? incomeCandidateAvg.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(incomeCandidateAvg.toString())
															? incomeCandidateAvg.toLocaleString('hr') + '0'
															: incomeCandidateAvg.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{
													discountCandidateAvg != null
														? Number.isInteger(discountCandidateAvg)
															? discountCandidateAvg.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(discountCandidateAvg.toString())
															? discountCandidateAvg.toLocaleString('hr') + '0'
															: discountCandidateAvg.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{
													costCandidateAvg != null
														? Number.isInteger(costCandidateAvg)
															? costCandidateAvg.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(costCandidateAvg.toString())
															? costCandidateAvg.toLocaleString('hr') + '0'
															: costCandidateAvg.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{
													profitCandidateAvg != null
														? Number.isInteger(profitCandidateAvg)
															? profitCandidateAvg.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(profitCandidateAvg.toString())
															? profitCandidateAvg.toLocaleString('hr') + '0'
															: profitCandidateAvg.toLocaleString('hr')
														: ''
												}}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Offices from './Offices.vue';
import IncomeAndCostsChart from './IncomeAndCostsChart.vue';
import ProfitChart from './ProfitChart.vue';
import NumberOfCandidatesChart from './NumberOfCandidatesChart.vue';

export default {
	name: 'Courses',
	components: { TheTable, Offices, IncomeAndCostsChart, ProfitChart, NumberOfCandidatesChart },
	data: function () {
		return {
			statsCoursesTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.department'),
						value: 'department',
						type: 'select_all|departments',
						allowFilter: true,
					},
					{
						text: this.$t('fields.code'),
						value: 'course_code',
						type: 'multiple|courses-codes',
						allowFilter: true,
					},
					{
						text: this.$t('fields.plannedCourse'),
						value: 'code',
						type: 'multiple|planned-courses-codes',
						allowFilter: true,
					},
					{
						text: this.$t('fields.status'),
						value: 'status',
						type: 'select_all|planned-course-statuses-filter',
						allowFilter: true,
					},
					{
						text: this.$t('fields.office'),
						value: 'office',
						type: 'select_all|offices',
						allowFilter: true,
					},
					{ text: this.$t('fields.startDate'), value: 'start_date', type: '', allowFilter: true },
					{
						text: this.$t('fields.netIncome'),
						value: 'income',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.netDiscount'),
						value: 'discount',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{ text: this.$t('fields.cost'), value: 'cost', type: '', allowFilter: true, alignRight: true },
					{
						text: this.$t('fields.netProfit'),
						value: 'profit',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{ text: this.$t('fields.registration'), value: 'registration', type: '', allowFilter: true },
					{
						text: this.$t('fields.incomeCandidate'),
						value: 'income_candidate',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.discountCandidate'),
						value: 'discount_candidate',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.costCandidate'),
						value: 'cost_candidate',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.profitCandidate'),
						value: 'profit_candidate',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
				],
				additionalFilters: [
					{ text: this.$t('fields.startDate'), value: 'start_date', type: 'date_range' },
					{ text: this.$t('fields.netIncome'), value: 'income', type: 'price_range' },
					{ text: this.$t('fields.netDiscount'), value: 'discount', type: 'price_range' },
					{ text: this.$t('fields.cost'), value: 'cost', type: 'price_range' },
					{ text: this.$t('fields.profit'), value: 'profit', type: 'price_range' },
					{ text: this.$t('fields.registration'), value: 'registration', type: 'number_range' },
					{ text: this.$t('fields.incomeCandidate'), value: 'income_candidate', type: 'price_range' },
					{ text: this.$t('fields.discountCandidate'), value: 'discount_candidate', type: 'price_range' },
					{ text: this.$t('fields.costCandidate'), value: 'cost_candidate', type: 'price_range' },
					{ text: this.$t('fields.profitCandidate'), value: 'profit_candidate', type: 'price_range' },
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '1000px',
				defaultSort: {
					field: 'income',
					descending: true,
				},
			},
			groupedByOffice: [],
			incomeAndCostsChartData: [],
			profitChartData: [],
			numberOfCandidatesChartData: [],
			incomeSum: 0,
			costSum: 0,
			profitSum: 0,
			discountSum: 0,
			registrationSum: 0,
			incomeCandidateAvg: 0,
			costCandidateAvg: 0,
			discountCandidateAvg: 0,
			profitCandidateAvg: 0,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.statsCoursesTable.selectedHeaders = headers;
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.statsCoursesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'stats-courses',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/stats-courses', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		enrolledCandidatesViewClick() {
			let excelRequest = JSON.parse(JSON.stringify(this.statsCoursesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;
			this.$APICall('get', 'excel/enrolled-candidates-view', excelRequest, (data, success) => {
				window.open(data.link);
			});
		},
		reloadData(request) {
			this.statsCoursesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'stats-courses',
				request,
				(data, success) => {
					if (success) {
						vm.statsCoursesTable.items = data.items;
						vm.groupedByOffice = data.offices_data.grouped_by_office;
						vm.incomeAndCostsChartData = data.offices_data.first_chart;
						vm.profitChartData = data.offices_data.second_chart;
						vm.numberOfCandidatesChartData = data.offices_data.third_chart;
						vm.statsCoursesTable.total = data.total;
						vm.incomeSum = data.income_sum;
						vm.costSum = data.cost_sum;
						vm.profitSum = data.profit_sum;
						vm.discountSum = data.discount_sum;
						vm.registrationSum = data.registration_avg;
						vm.incomeCandidateAvg = data.income_candidate_avg;
						vm.costCandidateAvg = data.cost_candidate_avg;
						vm.discountCandidateAvg = data.discount_candidate_avg;
						vm.profitCandidateAvg = data.profit_candidate_avg;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [{ text: this.$t('modules.stats'), href: '/#/stats', disabled: true }]);
	},
};
</script>

<style scoped></style>
